const en = {
    views: {
        home: {},
    },
};

export default en;
